import { z } from 'zod';
export const DISPUTABLE_STATUSES = ['pending-approval', 'approved'];
export const disputeStatusSchema = z.enum(['open', 'resolved', 'written-off', 'vendor-credit']);
export const disputeResolutionKindSchema = z.enum(['resolved', 'written-off', 'vendor-credit']);
export const disputeEventTypeSchema = z.enum([
    'full-dispute-raised',
    'partial-dispute-raised',
    'undisputed-portion-payment-approved',
    'dispute-resolved-payment-approved',
    'partial-dispute-resolved-remaining-payment-approved',
    'dispute-written-off',
    'partial-dispute-written-off',
    'dispute-resolved-vendor-credit',
    'qbo-bill-voided',
    'qbo-bill-adjusted',
    'qbo-vendor-credit-recorded',
    'qbo-side-effect-failed',
]);
export const disputeQboEffectSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('none') }),
    z.object({ kind: z.literal('pending') }),
    z.object({ kind: z.literal('bill-voided') }),
    z.object({ kind: z.literal('bill-adjusted'), newBillTotal: z.number() }),
    z.object({
        kind: z.literal('vendor-credit-created'),
        vendorCreditId: z.string(),
        amount: z.number(),
    }),
    z.object({ kind: z.literal('failed'), error: z.string() }),
]);
export const disputeResolutionInputSchema = z.discriminatedUnion('resolution', [
    z.object({
        resolution: z.literal('resolved'),
        resolutionNotes: z.string().trim().min(1),
    }),
    z.object({
        resolution: z.literal('written-off'),
        resolutionNotes: z.string().trim().min(1),
    }),
    z.object({
        resolution: z.literal('vendor-credit'),
        resolutionNotes: z.string().trim().min(1),
        creditAmount: z.number().positive(),
    }),
]);
export const disputeOutputSchema = z.object({
    disputeId: z.string(),
    invoiceDisplayId: z.string(),
    status: disputeStatusSchema,
    isFull: z.boolean(),
    totalAmount: z.number(),
    approvedAmount: z.number(),
    disputedAmount: z.number(),
    amountPaid: z.number(),
    amountRemaining: z.number(),
    canPayUndisputed: z.boolean(),
    reason: z.string(),
    raisedByUserDisplayId: z.string(),
    raisedByUserName: z.string(),
    raisedAt: z.string(),
    resolutionKind: disputeResolutionKindSchema.optional(),
    resolutionNotes: z.string().optional(),
    resolvedAt: z.string().optional(),
    qboEffect: disputeQboEffectSchema.optional(),
});
export function roundMoney(amount) {
    return Math.round((amount + Number.EPSILON) * 100) / 100;
}
export const MONEY_EPSILON = 0.005;
//# sourceMappingURL=disputes.js.map